import { useRecoilState } from "recoil";
import {
  confirmBasicAtom,
  confirmDriveAtom,
  confirmPlusAtom,
  confirmPromotionAtom,
  confirmTrialAtom,
} from "src/atoms";
import { getMyServiceList } from "src/service/console";
import { checkPromotionTrial, getMyServiceBill } from "src/service/pay";
import { useRouter } from "../useRouter";
import { ProductKey } from "src/config/config";

export function useGetMySiteStatus() {
  // 요금제별 사용 가능여부 세팅
  // 굳이 필요 없을듯?
  const [confirmTrial, setConfirmTrial] = useRecoilState(confirmTrialAtom);
  const [confirmDrive, setConfirmDrive] = useRecoilState(confirmDriveAtom);
  const [confirmBasic, setConfirmBasic] = useRecoilState(confirmBasicAtom);
  const [confirmPlus, setConfirmPlus] = useRecoilState(confirmPlusAtom);
  const [confirmPromotion, setConfirmPromotion] =
    useRecoilState(confirmPromotionAtom);
  const route = useRouter();

  async function getMySiteStatus({ priceType }: { priceType?: string }) {
    const serviceList = await getMyServiceList({
      product: sessionStorage.getItem("product") as string,
    });
    if (!Array.isArray(serviceList) || serviceList === null) {
      const myServiceBill = await getMyServiceBill({
        product: sessionStorage.getItem("product") as ProductKey,
      });
      if (myServiceBill.length >= 1) {
        setConfirmTrial(false);
      } else {
        const result = await checkPromotionTrial({
          product: sessionStorage.getItem("product") as ProductKey,
        });
        if (
          result.status === "IMPOSSIBLE" ||
          result.status === "EXIST" ||
          result.status === "T_APPLY" ||
          result.status === "T_USED" ||
          result.status === ""
        ) {
          setConfirmTrial(false);
        } else {
          setConfirmTrial(true);
        }
      }
      setConfirmDrive(true);
      setConfirmBasic(true);
      // setConfirmBasicPlus(true)
      setConfirmPlus(true);
      // setConfirmPlusPlus(true)
      setConfirmPromotion(true);
    } else {
      if (serviceList.length > 0) {
        if (serviceList[0].billType === "TRIAL") {
          setConfirmDrive(true);
          setConfirmBasic(true);
          // setConfirmBasicPlus( true)
          setConfirmPlus(true);
          // setConfirmPlusPlus( true)
          setConfirmPromotion(true);
        }

        if (serviceList[0].billType === "PAY") {
          setConfirmPromotion(true);
        }

        if (serviceList[0].billType === "PROMOTION") {
          setConfirmDrive(true);
          setConfirmBasic(true);
          // setConfirmBasicPlus(true);
          setConfirmPlus(true);
          // setConfirmPlusPlus(true);
          setConfirmPromotion(true);
        }
      }
    }

    // if (priceType === "plus" && !confirmPlus) {
    //   // window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`
    //   route.goConsole();
    // } else if (priceType === "drive" && !confirmDrive) {
    //   // window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`
    //   route.goConsole();
    // } else if (priceType === "basic" && !confirmBasic) {
    //   // window.location.href = `${process.env.PUBLIC_URL}/${lang}/console`
    //   route.goConsole();
    // }
  }

  return { getMySiteStatus };
}
